// extracted by mini-css-extract-plugin
module.exports = {"section":"N_JP_section__u4v4Q"};